import script from "./SectorsList.vue?vue&type=script&setup=true&lang=js"
export * from "./SectorsList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__